import { Typography, Box } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import PropTypes from 'prop-types';
import React from 'react';

const useStyles = makeStyles(() => ({
  gridContainer: {
    width: '100%',
    height: '100%',
    marginTop: 0,
    paddingTop: '8px',
    paddingBottom: '8px',
    paddingLeft: '12px',
    paddingRight: '12px',
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'stretch',
    justifyContent: 'space-evenly',
    gap: '8px',
    overflow: 'visible',
  },
  gridItem: {
    flex: '1 1 0',
    minWidth: 0,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '0 8px',
    boxSizing: 'border-box',
  },
  gridItemWithDivider: {
    borderLeft: '1px solid rgba(0, 0, 0, 0.15)',
  },
  textContainer: {
    display: 'grid',
    gridTemplateRows: '44px 88px',
    alignContent: 'center',
    justifyItems: 'center',
    rowGap: '6px',
    width: '100%',
    textAlign: 'center',
    minHeight: '170px',
  },
  valueRow: {
    width: '100%',
    height: '44px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  h5: {
    fontSize: '125%',
  },
  h4: {
    fontSize: '30px',
    lineHeight: 1.15,
    margin: 0,
  },
  body2: {
    display: 'block',
    fontSize: '10.5px',
    lineHeight: 1.2,
    width: '100%',
    maxWidth: '100%',
    height: '88px',
    textAlign: 'center',
    overflow: 'hidden',
    whiteSpace: 'normal',
    wordBreak: 'normal',
    overflowWrap: 'normal',
    hyphens: 'none',
  },
  outerContainer: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    height: '100%',
    minHeight: 0,
    boxSizing: 'border-box',
    justifyContent: 'center',
  },
}));

function TopHitsBox({ chartData, title, showTitle = true }) {
  const classes = useStyles();
  return (
    <Box className={classes.outerContainer}>
      {showTitle && (
        <Typography className={classes.h5} variant="h5" align="left" spacing={5}>
          {title}
        </Typography>
      )}
      <Box className={classes.gridContainer}>
        {chartData[0].map((unit, index) => {
          return (
            <Box
              key={`${unit?._id ?? 'no-unit'}-${index}`}
              className={`${classes.gridItem} ${index > 0 ? classes.gridItemWithDivider : ''}`}
            >
              <Box className={classes.textContainer}>
                <Box className={classes.valueRow}>
                  <Typography className={classes.h4} variant={'h5'}>
                    {unit.count}
                  </Typography>
                </Box>
                <Box className={classes.body2} variant={'body2'}>
                  {unit._id ? unit._id : 'No unit'}
                </Box>
              </Box>
            </Box>
          );
        })}
      </Box>
    </Box>
  );
}

TopHitsBox.propTypes = {
  chartData: PropTypes.array.isRequired,
  title: PropTypes.string,
  showTitle: PropTypes.bool,
};

export default TopHitsBox;
